import { api } from "@/api";
import { FullMatchDto } from "./getFullMatches";

// Puts a match closed by the 24-hour rule back into play; the server
// requires the lock and refuses a match the rule has not closed.
export const manualReopenMatch = async (matchId: string): Promise<FullMatchDto> => {
  const res = await api.client.post(`/matches/${matchId}/manual-reopen`);
  return res.data;
};
